export default class RelatorioFaturamentoCartaoFidelidadeFiltro {
  startDate: Date;
  endDate: Date;
  userId: number;
  data: any;
}
